module.exports = __webpack_public_path__ + "img/cian-logo.34b0deae.svg";